import { FC, ReactNode, useState } from 'react';
import { Sidebar } from './Sidebar';
import { Navbar } from './Navbar';
import { BottomNav } from './BottomNav';

interface DashboardLayoutProps {
  children: ReactNode;
  title?: string;
}

export const DashboardLayout: FC<DashboardLayoutProps> = ({ children, title }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      {/* Sidebar */}
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      {/* Main content */}
      <div className="lg:ml-64">
        {/* Navbar — masqué sur mobile (remplacé par BottomNav) */}
        <Navbar onMenuClick={() => setSidebarOpen(true)} title={title} />

        {/* Page content — padding-bottom sur mobile pour la BottomNav */}
        <main className="p-3 sm:p-4 lg:p-6 pb-20 lg:pb-6">
          {children}
        </main>
      </div>

      {/* Bottom navigation — mobile uniquement */}
      <BottomNav onMenuOpen={() => setSidebarOpen(true)} />
    </div>
  );
};
